/* Beauty Lounge: completeaza schema Liquid cu textul real al paginii.
 * Selectorii corespund temei verificate la 01.10.2026.
 * Contract: un produs cu o singura varianta. Fara cereri de retea.
 */
(() => {
  'use strict';
  if (window.__beautyLoungeProductSchema) return;
  const target = document.getElementById('beauty-lounge-product-schema');
  const source = document.getElementById('beauty-lounge-product-source');
  if (!target || !source) return;
  let original, data;
  try {
    original = JSON.parse(target.textContent);
    data = JSON.parse(source.textContent);
  } catch (error) {
    console.error('Beauty Lounge: JSON schema invalid.', error);
    return;
  }
  window.__beautyLoungeProductSchema = true;

  const SELECTORS = {
    title: 'h1.product__title',
    faq: '[data-product-tab="faq"] .metafield-rich_text_field',
    breadcrumb: '.breadcrumbs a[href*="/collections/"]',
    rating: '.jdgm-prev-badge[data-average-rating][data-number-of-reviews]'
  };
  const compact = text => text.replace(/\s+/g, ' ').trim();
  const textOf = node => compact(node?.textContent || '');

  // Pastreaza textul linkurilor, decodeaza entitatile HTML si separa blocurile.
  function plainText(node) {
    const clone = node.cloneNode(true);
    clone.querySelectorAll('script, style, template').forEach(n => n.remove());
    clone.querySelectorAll('br').forEach(n => n.replaceWith('\n'));
    clone.querySelectorAll('p, li, h1, h2, h3, h4, h5, h6, div, ul, ol, blockquote')
      .forEach(n => { n.before('\n'); n.after('\n'); });
    return clone.textContent.split('\n').map(compact).filter(Boolean).join('\n');
  }

  // Accepta intrebarea si raspunsul in paragrafe separate sau in acelasi
  // paragraf: <p><strong>Intrebare?</strong><br>Raspuns...</p>.
  // Raspunsurile pot continua in paragrafe/liste si pastreaza textul linkurilor.
  function readFAQ() {
    const container = document.querySelector(SELECTORS.faq);
    if (!container) return [];
    const result = [];
    let question = '', answer = [];
    const flush = () => {
      const text = answer.filter(Boolean).join('\n');
      if (question && text) result.push({
        '@type': 'Question', name: question,
        acceptedAnswer: { '@type': 'Answer', text }
      });
    };
    for (const node of container.children) {
      if (/^H[2-6]$/.test(node.tagName)) {
        flush();
        question = textOf(node);
        answer = [];
        continue;
      }
      const bold = node.tagName === 'P' ? node.querySelector('strong, b') : null;
      let isQuestion = false;
      let inlineAnswer = '';
      if (bold) {
        const before = document.createRange();
        before.selectNodeContents(node);
        before.setEndBefore(bold);
        const beginsWithQuestion = !compact(before.toString());
        const questionText = textOf(bold);
        isQuestion = beginsWithQuestion && questionText !== '' &&
          (questionText === textOf(node) || questionText.endsWith('?'));
        if (isQuestion) {
          const after = document.createRange();
          after.selectNodeContents(node);
          after.setStartAfter(bold);
          inlineAnswer = plainText(after.cloneContents());
        }
      }
      if (isQuestion) {
        flush();
        question = textOf(bold);
        answer = inlineAnswer ? [inlineAnswer] : [];
      } else if (question) {
        answer.push(plainText(node));
      }
    }
    flush();
    return result;
  }

  function update() {
    const schema = JSON.parse(JSON.stringify(original));
    const graph = schema['@graph'];
    const product = graph.find(n => n['@type'] === 'Product');
    const page = graph.find(n => Array.isArray(n['@type']) && n['@type'].includes('ItemPage'));
    const breadcrumb = graph.find(n => n['@type'] === 'BreadcrumbList');
    if (!product || !page || !breadcrumb) return;
    const title = textOf(document.querySelector(SELECTORS.title));
    if (title) product.name = page.headline = title;
    page.name = document.title;
    const meta = document.querySelector('meta[name="description"]')?.getAttribute('content');
    if (meta?.trim()) page.description = meta;
    else delete page.description;

    const description = document.createElement('template');
    description.innerHTML = data.descriptionHtml || '';
    product.description = plainText(description.content);
    product.image = product.image.map(url => new URL(url, product.url).href.replace(/^http:/, 'https:'));

    // Foloseste numai colectia brandului din breadcrumb-ul existent.
    const brand = Array.from(document.querySelectorAll(SELECTORS.breadcrumb)).find(link =>
      textOf(link).normalize('NFC').toLocaleLowerCase('ro') ===
      product.brand.name.normalize('NFC').toLocaleLowerCase('ro')
    );
    const items = [breadcrumb.itemListElement[0]];
    if (brand) items.push({
      '@type': 'ListItem', position: 2, name: product.brand.name,
      item: new URL(brand.getAttribute('href'), product.url).href
    });
    items.push({ '@type': 'ListItem', position: items.length + 1, name: product.name, item: product.url });
    breadcrumb.itemListElement = items;

    // Badge-ul este identificat prin ID-ul produsului, nu prin prima recenzie din pagina.
    const badge = Array.from(document.querySelectorAll(SELECTORS.rating)).find(node =>
      node.closest('.jdgm-widget[data-id]')?.getAttribute('data-id') === String(data.productId)
    );
    if (badge) {
      const count = Number(badge.getAttribute('data-number-of-reviews'));
      const rating = Number(badge.getAttribute('data-average-rating'));
      if (Number.isInteger(count) && count > 0 && Number.isFinite(rating) && rating >= 1 && rating <= 5) {
        product.aggregateRating = {
          '@type': 'AggregateRating', ratingValue: rating,
          reviewCount: count, bestRating: 5, worstRating: 1
        };
      }
    }

    const questions = readFAQ();
    if (questions.length) {
      const id = product.url + '#faqpage';
      graph.splice(graph.indexOf(breadcrumb), 0, {
        '@type': 'FAQPage', '@id': id, inLanguage: page.inLanguage,
        publisher: page.publisher, reviewedBy: page.reviewedBy, mainEntity: questions
      });
      page.hasPart = { '@id': id };
    }
    const json = JSON.stringify(schema).replace(/</g, '\\u003c');
    if (target.textContent !== json) target.textContent = json;
  }

  function start() {
    update();
    // Judge.me poate incarca sau actualiza badge-ul dupa DOMContentLoaded.
    // Debounce + compararea JSON-ului evita buclele de actualizare.
    let timer;
    const observer = new MutationObserver(records => {
      if (records.every(r => r.target === target || target.contains(r.target))) return;
      clearTimeout(timer);
      timer = setTimeout(update, 150);
    });
    observer.observe(document.body, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['data-average-rating', 'data-number-of-reviews']
    });
    window.addEventListener('pagehide', () => { observer.disconnect(); clearTimeout(timer); }, { once: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
